import reduxHistoryStateSlice from '@/features/app/stores/redux-history-state-slice';
import reduxMiscStateSlice from '@/features/app/stores/redux-misc-state-slice';
import reduxAuthStateSlice from '@/features/auth/stores/redux-auth-state-slice';
import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

export default configureStore({
  reducer: {
    [reduxAuthStateSlice.name]: reduxAuthStateSlice.reducer,
    [reduxHistoryStateSlice.name]: reduxHistoryStateSlice.reducer,
    [reduxMiscStateSlice.name]: reduxMiscStateSlice.reducer,
  },
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat([Sentry.createReduxEnhancer({})]),
});
